/*
  Sunne v2 – spärra dagar utanför säsongen i IzyRents kalender.

  IzyRent har varken säsongsstart eller säsongsslut. Appen kan bara kryssa i
  veckodagar och klicka bort enskilda datum, ett i taget, i all framtid. Utan
  hjälp gick det därför att boka en skidlektion den 8 september, mitt i
  bikeparksäsongen, och att hyra en downhillcykel i januari.

  Öppetdagarna finns redan i window.sv2Oppet, samma källa som temats egen
  kalender använder. Den här filen lägger dem ovanpå IzyRents flatpickr som en
  extra spärrfunktion. Appens egna spärrar – fullbokade datum, minsta antal
  nätter – ligger kvar orörda; vi lägger bara till våra.

  Vilken säsong som gäller står i produktens metafält custom.bokningssasong och
  skrivs ut av sektionen som window.sv2Bokningssasong. Saknas värdet, eller är
  det "alla", rör vi ingenting. Boende och ställplats bokas året runt.

  Går något fel gör filen ingenting alls. Hellre en valbar dag för mycket än en
  produktsida som inte går att boka på.
*/
(function () {
  'use strict';

  var typ = String(window.sv2Bokningssasong || '').toLowerCase();
  if (!typ || typ === 'alla') { return; }
  if (typ !== 'vinter' && typ !== 'sommar' && typ !== 'kvall') { return; }

  function tvasiffrigt(tal) {
    if (tal < 10) { return '0' + String(tal); }
    return String(tal);
  }

  function iso(datum) {
    return String(datum.getFullYear()) + '-' +
           tvasiffrigt(datum.getMonth() + 1) + '-' +
           tvasiffrigt(datum.getDate());
  }

  function regler() {
    var k = window.sv2Oppet;
    if (!k) { return null; }
    var sasong = (typ === 'sommar') ? k.sommar : k.vinter;
    if (!sasong) { return null; }
    /* Kvallsakning gar tisdag och torsdag under vintern och har en egen lista. */
    var perioder = (typ === 'kvall') ? sasong.kvall : sasong.dag;
    if (!perioder || !perioder.length) { return null; }
    return { perioder: perioder, stangt: sasong.stangt || [] };
  }

  function arOppen(datum, r) {
    var s = iso(datum);
    if (r.stangt.indexOf(s) !== -1) { return false; }
    var veckodag = datum.getDay();
    var i;
    for (i = 0; i < r.perioder.length; i++) {
      var p = r.perioder[i];
      if (s >= p.fran && s <= p.till && p.dagar.indexOf(veckodag) !== -1) { return true; }
    }
    return false;
  }

  var r = regler();
  if (!r) { return; }

  function stangd(datum) {
    try { return !arOppen(datum, r); } catch (e) { return false; }
  }

  /* IzyRent skriver om disable-listan varje gang appen hamtar om
     tillgangligheten, och slanger da var funktion. Darfor kollar vi varje
     varv om den finns kvar i stallet for att lagga till den en gang. */
  function koppla(falt) {
    var fp = falt._flatpickr;
    if (!fp || !fp.config) { return; }
    var fanns = fp.config.disable || [];
    var i;
    for (i = 0; i < fanns.length; i++) {
      if (fanns[i] === stangd) { return; }
    }
    var nya = fanns.slice(0);
    nya.push(stangd);
    try { fp.set('disable', nya); } catch (e) {}
  }

  /* Forsta oppna dagen fran och med start, inom hogst 500 dagar. */
  function forstaOppna(start) {
    var d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    var i;
    for (i = 0; i < 500; i++) {
      if (arOppen(d, r)) { return new Date(d.getTime()); }
      d.setDate(d.getDate() + 1);
    }
    return null;
  }

  var MANADER = ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli',
                 'augusti', 'september', 'oktober', 'november', 'december'];

  function svenskt(datum) {
    return String(datum.getDate()) + ' ' + MANADER[datum.getMonth()] +
           ' ' + String(datum.getFullYear());
  }

  /* IzyRent oppnar bara ett bokningsfonster nagra manader fram. Ligger hela
     sasongen bortom det fonstret star kunden med en kalender dar ingen dag gar
     att valja och ingen forklaring alls. Da sager vi det i klartext i stallet. */
  function beratta(fp) {
    var vard = fp && fp.config ? fp.config.maxDate : null;
    if (!vard) { return; }
    var forsta = forstaOppna(new Date());
    if (!forsta) { return; }
    if (forsta.getTime() <= new Date(vard).getTime()) { return; }

    var plats = document.getElementById('izyrent');
    if (!plats || document.getElementById('sv2-sasong-notis')) { return; }
    var ruta = document.createElement('p');
    ruta.id = 'sv2-sasong-notis';
    ruta.setAttribute('role', 'status');
    ruta.style.cssText = 'margin:12px 0 0;padding:14px 16px;background:#fff7e1;' +
      'border:1px solid #f0e2b8;border-radius:8px;font-size:16px;line-height:1.5;';
    ruta.textContent = (typ === 'vinter'
      ? 'Vintersäsongen börjar '
      : 'Bikeparksäsongen börjar ') + svenskt(forsta) +
      '. Bokningen öppnar närmare säsongsstart – hör gärna av dig på 0565 747 047 om du vill boka redan nu.';
    plats.appendChild(ruta);
  }

  function svep() {
    var falt = document.querySelectorAll('.izyDate');
    var i;
    for (i = 0; i < falt.length; i++) {
      if (falt[i]._flatpickr) {
        koppla(falt[i]);
        beratta(falt[i]._flatpickr);
      }
    }
  }

  /* Bevakningen kan slå till många gånger per ritning. Vi stryper den så att
     svep() körs högst en gång per bildruta. */
  var svepKoad = false;
  function svepSnart() {
    if (svepKoad) { return; }
    svepKoad = true;
    requestAnimationFrame(function () {
      svepKoad = false;
      svep();
    });
  }

  /* Appen bygger kalendern långt efter att sidan laddat, och bygger om den
     när kunden byter variant. Därför både bevakning och en tickande koll. */
  if (window.MutationObserver) {
    new MutationObserver(svepSnart)
      .observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Ingen sluttid pa kollen. Byter kunden variant eller antal bygger appen om
     kalendern, och da maste sparren tillbaka. Arbetet ar en jamforelse per
     falt varje sekund, vilket inte marks. */
  /* Ligger fliken i bakgrunden behöver kalendern inte ses om. */
  setInterval(function () {
    if (document.hidden) { return; }
    svep();
  }, 700);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', svep);
  } else {
    svep();
  }
})();
